import type {ReactNode} from 'react';
import classNames from 'classnames';
import {ProgressBar} from '@react-spectrum/progress';

import type {FileInfo} from '../../../utils/attachments/types';
import {AttachmentCard, AttachmentCardActions, AttachmentCardText} from '../../../atoms/attachment';
import {AttachmentThumbnail} from '../../../molecules/attachment-thumbnail';
import {fileSizeToString, getFileType} from '../../../utils/attachments/utils';

import styles from './attachment-preview.module.css';

type Props = {
    fileInfo: FileInfo;
    getThumbnailUrl: (id: string) => string;
    action?: ReactNode;
    progress?: number;
    className?: string;
};

export const AttachmentPreview = ({fileInfo, getThumbnailUrl, action, progress, className}: Props) => {
    const fileType = getFileType(fileInfo.extension);

    return (
        <AttachmentCard className={classNames(styles.root, className)}>
            <AttachmentThumbnail
                src={getThumbnailUrl(fileInfo.id)}
                fileName={fileInfo.name}
                fileType={fileType}
                fileExtension={fileInfo.extension}
            />
            <AttachmentCardText
                textPrimary={fileInfo.name}
                textSecondary={
                    progress ? (
                        <div className={styles.progress}>
                            <ProgressBar value={progress} />
                        </div>
                    ) : (
                        `${fileSizeToString(fileInfo.size)}`
                    )
                }
            />
            <AttachmentCardActions className={styles.actions}>{action}</AttachmentCardActions>
        </AttachmentCard>
    );
};
